module.exports = __webpack_public_path__ + "img/big-featured-image.ce86a167.jpg";